'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _createColorPalette = require('./createColorPalette'),
    _createColorPalette2 = _interopRequireDefault(_createColorPalette);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ocean = {
  1: '#eaf7fc',
  2: '#b0e3f4',
  3: '#75cfec',
  4: '#00a7db',
  5: '#0093c4',
  6: '#007fad',
  7: '#006c94',
  8: '#005a75',
  9: '#00465c',
  10: '#003342',
  inflection: 6
};
exports.default = (0, _createColorPalette2.default)(ocean, 'ocean');